/* eslint-disable camelcase */
import { DaoModel } from './daoModel';

export const COMPLETION_THRESHOLDS = {
  managedProducts: 10
};
export const COMPLETION_WEIGHTS = {
  managedProducts: 20, referencePrices: 20, minMaxPrices: 20, processingSpeeds: 10, unitCosts: 20, stocks: 10
};

export class ProfileCompletion extends DaoModel {
  constructor(point_of_sale, managed_products, unit_costs, reference_prices, min_max_prices, processing_speeds, stocks) {
    super('');
    this.pointOfSale = point_of_sale;
    this.managedProducts = managed_products;
    this.unitCosts = unit_costs;
    this.referencePrices = reference_prices;
    this.minMaxPrices = min_max_prices;
    this.processingSpeeds = processing_speeds;
    this.stocks = stocks;
  }

  static toInstance(props = {}) {
    return new ProfileCompletion(props.point_of_sale, props.managed_products, props.unit_costs,
      props.reference_prices, props.min_max_prices, props.processing_speeds, props.stocks);
  }

  get managedProducts100() {
    return this.#calculateValue('managedProducts');
  }

  get unitCosts100() {
    return this.#calculateValue('unitCosts');
  }

  get referencePrices100() {
    return this.#calculateValue('referencePrices');
  }

  get minMaxPrices100() {
    return this.#calculateValue('minMaxPrices');
  }

  get processingSpeedsCalculated() {
    return this.processingSpeeds >= COMPLETION_THRESHOLDS.managedProducts;
  }

  get stocksCalculated() {
    return this.stocks >= COMPLETION_THRESHOLDS.managedProducts / 2;
  }

  get managedProductsWeight() {
    return this.#weightedValue('managedProducts');
  }

  get unitCostsWeight() {
    return this.#weightedValue('unitCosts');
  }

  get referencePricesWeight() {
    return this.#weightedValue('referencePrices');
  }

  get minMaxPricesWeight() {
    return this.#weightedValue('minMaxPrices');
  }

  get processingSpeedsWeight() {
    return this.processingSpeedsCalculated ? COMPLETION_WEIGHTS.processingSpeeds : 0;
  }

  get stocksWeight() {
    return this.stocksCalculated ? COMPLETION_WEIGHTS.stocks : 0;
  }

  get percentage() {
    return this.managedProductsWeight + this.unitCostsWeight + this.referencePricesWeight
      + this.minMaxPricesWeight + this.processingSpeedsWeight + this.stocksWeight;
  }

  #calculateValue(field) {
    /* Clip it between 0 and 100 */
    const res = Math.max(Math.min((this[field] / (COMPLETION_THRESHOLDS[field] || COMPLETION_THRESHOLDS.managedProducts)) * 100, 100), 0);
    if (!Number.isNaN(res)) {
      return res;
    }
    return 0;
  }

  #weightedValue(field) {
    return (this.#calculateValue(field) * COMPLETION_WEIGHTS[field]) / 100;
  }
}
